import Vue from 'vue';
import Component from 'vue-class-component';

import ConfigurableSettingView from "@/views/settings/ConfigurableSettingView";
import {MeasureUnitKey} from "@/components/properties/settings/measure-units/model/MeasureUnitKey";
import {VolumeUnit} from "@/components/properties/settings/measure-units/model/VolumeUnit";
import {WeightUnit} from "@/components/properties/settings/measure-units/model/WeightUnit";
import {DimensionUnit} from "@/components/properties/settings/measure-units/model/DimensionUnit";


@Component({
  components: {ConfigurableSettingView},
  computed: {
    MeasureUnitKey() {
      return MeasureUnitKey;
    },
    VolumeUnit() {
      return VolumeUnit;
    },
    WeightUnit() {
      return WeightUnit;
    },
    DimensionUnit() {
      return DimensionUnit;
    }
  }
})
export default class MeasureUnitsSettingsView extends Vue {
}
